module.exports = __webpack_public_path__ + "static/img/C1.d29ab44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl2/C1.png
// module id = E5h6
// module chunks = 0